// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__3utla","dashed":"Divider_dashed__1iw8b"};